import Model  from '@/util/models';

export default class Permission extends Model { 
    backend = '/rbac/permission/'; 
   
    assign(items, params){                        
        return this.api.post(this.backend + 'assign', items, params); 
    }    
    
    remove(items, params){                        
        return this.api.post(this.backend + 'remove', items, params); 
    }  
    
    view(params){                        
        return this.api.post(this.backend + 'view', {}, params); 
    }  
}

